import { render, staticRenderFns } from "./IndexMallVoucherItem.vue?vue&type=template&id=b028e288&scoped=true"
import script from "./IndexMallVoucherItem.vue?vue&type=script&lang=js"
export * from "./IndexMallVoucherItem.vue?vue&type=script&lang=js"
import style0 from "./IndexMallVoucherItem.vue?vue&type=style&index=0&id=b028e288&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b028e288",
  null
  
)

export default component.exports